import api from 'src/api';
import omit from 'lodash/omit';
import isArray from 'lodash/isArray';
import keyBy from 'lodash/keyBy';

export default {
    namespaced: true,
    state: {
        fetchedCurrent: false,
        current: {},
        grosses: [],
        list: {},
    },
    mutations: {
        setCurrent(state, week) {
            state.current = week;
            state.fetchedCurrent = true;
        },
        setGrosses(state, grosses) {
            state.grosses = grosses;
        },
        add(state, weeks) {
            if (!isArray(weeks)) {
                weeks = [weeks];
            }

            weeks = weeks.map(week => ({
                ...state.list[week.id],
                ...week,
            }));

            state.list = {
                ...state.list,
                ...keyBy(weeks, 'id'),
            };
        },
    },
    getters: {
        current: state => {
            if (!state.fetchedCurrent) {
                return false;
            }

            return state.current;
        },
    },
    actions: {
        init({ commit, dispatch, state }, data) {
            commit('setGrosses', data.grosses.data);

            commit('setCurrent', omit(data, 'grosses'));

            const shows = data.grosses.data.map(gross => gross.show);

            dispatch('shows/add', shows, { root: true });
        },
        fetchCurrent({ dispatch, state }) {
            const homeData = window.broadwayBusiness.initialData.home;

            if (homeData && homeData.currentWeek) {
                return dispatch('init', homeData.currentWeek);
            }

            if (state.fetchedCurrent) {
                return;
            }

            return api.get('search').then(result => {
                dispatch('init', result.data);
            });
        },
    },
};
